import classNames from 'classnames';
import { theme } from 'styles/theme/theme';
import { Divider } from 'ud-ui/components';
import { DivProps } from '../../../../../typings';
import UDText from '../../../../ud-ui/components/text';

function Advertisement(props: DivProps) {
  return (
    <div id="advertisement" {...props} className={classNames('flex-center gap-4', props.className)}>
      <div id="logo" className="flex flex-row">
        <UDText id="logo-im" type="subhead" className="fw-800" style={{ fontSize: 60, color: theme.colors.DarkYellow }}>
          Im
        </UDText>
        <UDText id="logo-game" type="subhead" className="fw-800" style={{ fontSize: 60, color: 'white' }}>
          Game
        </UDText>
      </div>

      <Divider id="divider" type="vertical" color="white" width={'6px'} height={'60px'} />

      <div className="flex flex-col justify-center">
        <UDText
          id="url"
          type="subhead"
          className="fw-700"
          style={{
            fontSize: 32,
            lineHeight: '32px',
            color: 'white',
          }}
        >
          www.imgameapp.ru
        </UDText>

        <UDText
          id="description"
          type="subhead"
          className="fw-500 mt-1"
          style={{
            fontSize: 24,
            lineHeight: '24px',
            color: 'white',
          }}
        >
          цифровое спортивное табло
        </UDText>
      </div>
    </div>
  );
}

export default Advertisement;
